import { render, staticRenderFns } from "./PostTweet.vue?vue&type=template&id=6a09b7b4&scoped=true"
import script from "./PostTweet.vue?vue&type=script&lang=js"
export * from "./PostTweet.vue?vue&type=script&lang=js"
import style0 from "./PostTweet.vue?vue&type=style&index=0&id=6a09b7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09b7b4",
  null
  
)

export default component.exports